import styled from "styled-components";

const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between; // Keep this for vertical alignment

  @media (min-width: 768px) {
    flex-direction: row; // Switch to row on larger screens
    align-items: center; // Center vertically
  }
`;

export default CardHeader;
